module.exports = __webpack_public_path__ + "static/media/program.cd776b7a.png";